import * as groupAssignmentActionTypes from "../actionTypes/groupAssignmentActionTypes";
import { makeActionCreator } from "../../../../Application/actions/actionsBuilder";
import { type Dispatcher } from "../../../../../interfaces/redux";
import DataService from "../../../../Application/services/dataServices/typedDataService";
import { type SortingDirection } from "enums";
import { escapeTerm } from "utils/searchUtils";

export type FetchGroupsRequest = {
  skip: number;
  top: number;
  sortBy?: string;
  sortOrder?: SortingDirection;
  term?: string;
};

const fetchGroupsBegin = makeActionCreator(groupAssignmentActionTypes.LIBRARY_GROUP_ASSIGNMENTS_FETCH_GROUPS_BEGIN);
const fetchGroupsSuccess = makeActionCreator(
  groupAssignmentActionTypes.LIBRARY_GROUP_ASSIGNMENTS_FETCH_GROUPS_SUCCESS,
  "items",
  "itemsCount",
);
const fetchGroupsFailure = makeActionCreator(
  groupAssignmentActionTypes.LIBRARY_GROUP_ASSIGNMENTS_FETCH_GROUPS_FAILURE,
  "error",
);

export const fetchGroups = ({ top, skip, ...rest }: FetchGroupsRequest) => {
  return async (dispatch: Dispatcher) => {
    dispatch(fetchGroupsBegin());
    try {
      if (rest.term) {
        rest.term = escapeTerm(rest.term.trim());
      }
      const result = await DataService.groups.getGroupsV2({
        skip,
        top,
        ...rest,
      });
      let recordsCount = result.count;

      dispatch(fetchGroupsSuccess(result.items, recordsCount));
    } catch (error) {
      dispatch(fetchGroupsFailure(error));
    }
  };
};

export const setFilter = makeActionCreator(
  groupAssignmentActionTypes.LIBRARY_GROUP_ASSIGNMENTS_SET_ITEMS_FILTER,
  "filter",
);
export const resetFilter = makeActionCreator(groupAssignmentActionTypes.LIBRARY_GROUP_ASSIGNMENTS_RESET_ITEMS_FILTER);
